import styled, { css } from "styled-components";

const ButtonStyled = styled.button` 
        padding: 16px;
        width: 170px;
        background: #008755 !important;
        height: 50px !important;
        color: white;
        font-size: 1.6rem;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: ${props => props.theme.subHeading};
        border-radius: 5px;

        @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            height: 60px;
    }


`;




export { ButtonStyled };